import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { yupSchemaStep3 } from "schemas/yupSchema";
import { prepareDataStep3 } from "helpers/PrepareData";
import { goToTop, refToErrorFormik } from "helpers/helpers";
import { requestJson, RequestMethod } from "helpers/httpHelper";
import { toast } from "react-toastify";
import objectsSchema from "schemas/objectsSchema";
import SignatureCanvas from "react-signature-canvas";
import Step3Intro from "components/Step3/Step3Intro";
import NavigateButtons from "components/NavigateButtons";
import CustomInput from "components/CustomInput";
import CustomSelect from "components/CustomSelect";

export default function Step3({
   currentStep,
   setCurrentStep,
   setLoading,
   stepsState,
   persistState,
   setRedirectFinalStep,
   firstSubmit,
   setFirstSubmit,
}) {
   const formik = useFormik({
      enableReinitialize: true,
      initialValues: stepsState.step3,
      validationSchema: yupSchemaStep3,
      validateOnChange: firstSubmit,
      validateOnBlur: false,
      onSubmit: values => {
         goToTop();
         saveData(values);
      },
   });

   const [isVisibleStep3Intro, setIsVisibleStep3Intro] = useState(true);

   let signPad = useRef({});
   let signatureData = "";
   const saveSignature = () => {
      if (signPad.current?.isEmpty() || formik.values.semnatura) return;
      signatureData = signPad.current.toDataURL();
      formik.setFieldValue("semnatura", signatureData);
   };
   const clearSignature = () => {
      formik.setFieldValue("semnatura", "");
      if (signPad.current) {
         signPad.current.clear();
      }
   };

   const saveData = async values => {
      setLoading(true);
      // console.log("values3", stepsState);
      const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS3, RequestMethod.POST, {
         data: prepareDataStep3({ ...values, step1: stepsState.step1, step2: stepsState.step2 }),
      });
      // daca response este ok si exista se genereaza id-ul oportunitatii => treci mai departe
      if (response.isSuccess && response.response.opportunityid.length > 5) {
         persistState(prevState => {
            return {
               ...prevState,
               step3: {
                  ...prevState.step3,
                  tipCetatenie: values.tipCetatenie,
                  nif: values.nif, //Ceatean_STRAIN
                  tara: values.tara, //Ceatean_STRAIN
                  prenume: values.prenume,
                  nume: values.nume,
                  email: values.email,
                  emailConfirm: values.emailConfirm,
                  telefon: values.telefon,
                  cnp: values.cnp, //Cetatean_ROMAN
                  semnatura: values.semnatura,
                  newsletter: values.newsletter,
                  analytics: values.analytics,
               },
               opportunityId: response.response.opportunityid,
            };
         });
         window.dataLayer.push({ event: "pas_3_casnici", info: { pagina: "step-3", finalizat: "da" } });
         setCurrentStep(currentStep + 1);
         localStorage.setItem("sessionCurrentStep", currentStep + 1);
         setFirstSubmit(false);
      } else {
         toast.error("Eroare la salvarea datelor. Va rugam sa incercati din nou.");
      }
      setLoading(false);

      return response;
   };

   // daca nu sunt de acord cu GDPR => redirect la ultimul pas (10)
   const notAgreeGDPR = () => {
      setRedirectFinalStep("NU_SUNT_DE_ACCORD_GDPR");
      goToTop();
      setCurrentStep(10);
      localStorage.clear();
   };

   const formSubmition = e => {
      e.preventDefault();
      setFirstSubmit(true);
      formik.handleSubmit();
   };

   useEffect(() => {
      refToErrorFormik(formik);
   }, [formik]);

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  {isVisibleStep3Intro ? (
                     <Step3Intro
                        setFieldValue={formik.setFieldValue}
                        setIsVisibleStep3Intro={setIsVisibleStep3Intro}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                     />
                  ) : (
                     <div className="pas-3">
                        <h2 className="first_title">Acord preluare și procesare date</h2>
                        <p>
                           Prin introducerea semnăturii în câmpul de mai jos, îți dai acordul pentru prelucrarea datelor cu caracter personal
                           (semnătură, nume, prenume, adresă, datele de identificare regăsite în actul de identitate, serie și număr carte de
                           identitate, numar de identificare fiscala). Mai multe detalii și informații despre prelucrarea datelor cu caracter personal și
                           procesarea documentelor găsești{" "}
                           <a className="cursor-pointer color-green t-decoration" href="/gdpr" target="_blank">
                              aici
                           </a>
                           .
                        </p>
                        <form onSubmit={e => formSubmition(e)}>
                           <div className="row row-input mt-50">
                              <div className="col-md-6 mb-768">
                                 <label htmlFor="prenume">Prenume</label>
                                 <CustomInput
                                    id={"prenume"}
                                    name={"prenume"}
                                    type={"text"}
                                    placeholder={"Prenumele complet din actul de identitate"}
                                    value={formik.values.prenume}
                                    error={formik.errors.prenume}
                                    touched={formik.touched.prenume}
                                    setFieldValue={formik.setFieldValue}
                                    preventNumbers={true}
                                 />
                              </div>
                              <div className="col-md-6">
                                 <label htmlFor="nume">Nume</label>
                                 <CustomInput
                                    id={"nume"}
                                    name={"nume"}
                                    type={"text"}
                                    placeholder={"Numele complet din actul de identitate"}
                                    value={formik.values.nume}
                                    error={formik.errors.nume}
                                    touched={formik.touched.nume}
                                    setFieldValue={formik.setFieldValue}
                                    preventNumbers={true}
                                 />
                              </div>
                           </div>
                           <div className="row row-input mt-50">
                              <div className="col-md-6 mb-768">
                                 <label htmlFor="email">E-mail</label>
                                 <CustomInput
                                    id={"email"}
                                    name={"email"}
                                    type={"email"}
                                    placeholder={"Adresa ta de email"}
                                    value={formik.values.email}
                                    error={formik.errors.email}
                                    touched={formik.touched.email}
                                    setFieldValue={formik.setFieldValue}
                                    onCopy={e => e.preventDefault()}
                                    onPaste={e => e.preventDefault()}
                                 />
                              </div>
                              <div className="col-md-6">
                                 <label htmlFor="emailConfirm">Confirmă email</label>
                                 <CustomInput
                                    id={"emailConfirm"}
                                    name={"emailConfirm"}
                                    type={"email"}
                                    placeholder={"Confirmă adresa ta de email"}
                                    value={formik.values.emailConfirm}
                                    error={formik.errors.emailConfirm}
                                    touched={formik.touched.emailConfirm}
                                    setFieldValue={formik.setFieldValue}
                                    onCopy={e => e.preventDefault()}
                                    onPaste={e => e.preventDefault()}
                                 />
                              </div>
                           </div>
                           <div className="row row-input mt-50">
                              <div className="col-md-6 mb-768">
                                 <label htmlFor="telefon">Telefon mobil</label>
                                 <CustomInput
                                    id={"telefon"}
                                    name={"telefon"}
                                    type={"text"}
                                    placeholder={"Numărul tău de telefon"}
                                    value={formik.values.telefon}
                                    error={formik.errors.telefon}
                                    touched={formik.touched.telefon}
                                    setFieldValue={formik.setFieldValue}
                                    maxLengthNumber={formik.values.tipCetatenie === "ROMAN" ? 8 : undefined}
                                    phone={formik.values.tipCetatenie === "ROMAN" ? true : false}
                                    customStyle={formik.values.tipCetatenie === "ROMAN" && "input-phone"}
                                    allowNumbersAndPlus={formik.values.tipCetatenie === "ROMAN" ? undefined : true}
                                 />
                              </div>
                              {formik.values.tipCetatenie === "ROMAN" ? (
                                 <div className="col-md-6">
                                    <label htmlFor="cnp">CNP</label>
                                    <CustomInput
                                       id={"cnp"}
                                       name={"cnp"}
                                       type={"text"}
                                       placeholder={"CNP-ul tău"}
                                       value={formik.values.cnp}
                                       error={formik.errors.cnp}
                                       touched={formik.touched.cnp}
                                       setFieldValue={formik.setFieldValue}
                                       maxLengthNumber={13}
                                    />
                                 </div>
                              ) : (
                                 <div className="col-md-6">
                                    <label htmlFor="nif">NIF</label>
                                    <CustomInput
                                       id={"nif"}
                                       name={"nif"}
                                       type={"number"}
                                       placeholder={"NIF-ul tău"}
                                       value={formik.values.nif}
                                       error={formik.errors.nif}
                                       touched={formik.touched.nif}
                                       allowNumbersAndPlus={true}
                                       setFieldValue={formik.setFieldValue}
                                    />
                                 </div>
                              )}
                           </div>
                           {formik.values.tipCetatenie === "STRAIN" && (
                              <div className="row row-input mt-50">
                                 <div className="col-md-6">
                                    <CustomSelect
                                       options={objectsSchema.countriesOptions}
                                       value={formik.values.tara}
                                       onChange={value => formik.setFieldValue("tara", value.value)}
                                       placeholder="Alege Țara..."
                                       id={"tara"}
                                       isError={formik.errors.tara && formik.touched.tara}
                                       name={"tara"}
                                       labelDescription={"Țara"}
                                       obligatoriu={true}
                                    />
                                    {formik.errors.tara && formik.touched.tara && <div className="error-msg">{formik.errors.tara}</div>}
                                 </div>
                              </div>
                           )}

                           <label id="semnatura" htmlFor="semnatura">
                              <p>Semnatură (semnează cu mouse sau pad)</p>
                              {formik.values.semnatura ? (
                                 <div>
                                    <img src={formik.values.semnatura} alt="semnatura" className="semnatura-img" />
                                 </div>
                              ) : (
                                 <SignatureCanvas ref={signPad} canvasProps={{ width: "880", height: "200", className: "signCanvas" }} />
                              )}
                              <button type="button" className="dont-agree color-gray2 mb-3 mt-2" onClick={() => clearSignature()}>
                                 Șterge semnătura
                              </button>
                              <button type="button" className="dont-agree agree-button ms-4 mb-3 mt-2" onClick={() => saveSignature()}>
                                 Confirmă semnătura
                              </button>
                              {formik.errors.semnatura && formik.touched.semnatura ? (
                                 <div className="error-msg">{formik.errors.semnatura}</div>
                              ) : null}
                           </label>

                           <div className="row row-input mt-50">
                              <div className="col-md-12">
                                 <label htmlFor="newsletter" className="check2">
                                    Sunt de acord să fiu abonat la newsletter și să primesc notificări și informații în scop de marketing
                                    <input
                                       defaultChecked={formik.values.newsletter}
                                       value={formik.values.newsletter}
                                       onChange={formik.handleChange}
                                       id="newsletter"
                                       type="checkbox"
                                    />
                                    <span className="checkmark2"></span>
                                 </label>
                              </div>
                           </div>
                           <div className="row row-input mt-50">
                              <div className="col-md-12">
                                 <label htmlFor="analytics" className="check2">
                                    Sunt de acord să fiu contactat pe e-mail pentru efectuarea de studii și cercetări de piață sau în scop statistic
                                    <input
                                       defaultChecked={formik.values.analytics}
                                       value={formik.values.analytics}
                                       onChange={formik.handleChange}
                                       id="analytics"
                                       type="checkbox"
                                    />
                                    <span className="checkmark2"></span>
                                 </label>
                              </div>
                           </div>
                           <div className="text-center mt-50 col-md-12 last-buttons">
                              <a onClick={() => notAgreeGDPR()} className="mt-30 order-last dont-agree second-link mr-3 color-gray2 font-weight-400">
                                 Nu sunt de acord
                              </a>
                              <button type="submit" className="agree main-link bg-green d-inline-block w-auto mt-2">
                                 <span>Sunt de acord</span>
                                 <i className="fa fa-angle-right ml-5"></i>
                              </button>
                           </div>
                        </form>
                        <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep} next={"displayNone"} />
                     </div>
                  )}
               </div>
            </div>
         </div>
      </section>
   );
}
